import React from "react";
import { EiacFilesInfoContainer } from "./eiac-files-info-style";

const EiacFilesInfo = () => {
  return (
    <EiacFilesInfoContainer>
      <h2>Funcionamiento de los ficheros EIAC en ASISA</h2>
      <p>
        <strong>¿Que son los ficheros EIAC? </strong>Generalmente, cada compañía dispone de su
        propio formato de intercambio de datos, aspecto que hasta la fecha ha dificultado el
        mantenimiento de todo el software relacionado con procesos de integración entre compañías y
        mediadores. Para dar respuesta a esta complejidad, nació el proyecto EIAC, un estándar
        abierto de intercambio de datos a nivel sectorial que permite su uso por parte de distintas
        compañías para un variado número de procesos, elementos y ramos.
      </p>
      <p>
        "EIAC (Estándar de Intercambio de Información entre Entidades Aseguradoras y Mediadores), es
        un protocolo estándar y abierto de intercambio de datos a nivel sectorial que permite su uso
        por parte de las compañías aseguradoras y los corredores en un variado número de procesos,
        elementos y ramos."
      </p>
      <p>
        <strong>Acceso desde CIMA: </strong>Las credenciales que se proporcionan cuando inician la
        actividad con ASISA, son las mismas para el acceso a los ficheros desde CIMA. En caso de
        fallo en las credenciales, han de ponerse en contacto con soporte web para su reseteo.
      </p>
      <p className="list-title">
        <strong>Nomenclaturas de los ficheros:</strong>
      </p>
      <ul>
        <li>
          <strong>REC/RECI: </strong>Si contiene alguna de las dos palabras se trata de un fichero
          de Recibos
        </li>
        <li>
          <strong>POL/POLI: </strong>Si contiene alguna de las dos palabras se trata de un fichero
          de Polizas
        </li>
        <li>
          <strong>Carga Masiva: </strong>Los ficheros de carga masiva se detectan porque en su
          nombre incluyen un 199 o un 299.
        </li>
        <li>
          <strong>Subramos: </strong>Los ficheros que contienen la palabra VIDA corresponden a las
          pólizas y recibos de ASISA VIDA, el resto de los ficheros contienen solo la palabra ASISA,
          y corresponden a todos los subramos distintos de VIDA.
        </li>
      </ul>

      <p className="list-title">
        <strong>Generación de los ficheros:</strong>
      </p>
      <ul>
        <li>
          Los ficheros EIAC diarios en el sistema GIP se procesan los lunes, miércoles y viernes. En
          SENDA de forma semanal, los sábados. Los mensuales salen los días 7 y 26 de cada mes.
        </li>
        <li>Las cargas masivas se generan a demanda.</li>
      </ul>

      <p className="list-title">
        <strong>Consultas más recurrentes en información de los ficheros: </strong>
      </p>
      <ul>
        <li>
          <strong>Ficheros Pólizas:</strong>
          <ul>
            <li>
              Comunicación del valor número de póliza. Según el tipo de colectivo tratado se
              indicará el valor del campo IdPoliza de la siguiente manera:
              <ul>
                <li>
                  <strong>Colectivos Cerrados con Certificados</strong>
                  <ul>
                    <li>
                      En el campo IDPoliza se indica el código de colectivo + número de póliza +
                      número de certificado. Ejemplo:
                      <ul>
                        <li>
                          <strong>IDPOLIZA: 23106-20180005-1</strong>
                        </li>
                        <li>
                          <strong>IDAPLICACION: [vacío]</strong>
                        </li>
                        <li>
                          <strong>IDPOLIZA: 23106-20180005-2</strong>
                        </li>
                        <li>
                          <strong>IDAPLICACION: [vacío]</strong>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <strong>Colectivos abiertos y cerrados sin certificados</strong>
                  <ul>
                    <li>
                      En el campo IDPoliza se indica el código de colectivo + número de póliza.
                      Ejemplo:
                    </li>
                    <ul>
                      <li>
                        <strong>IDPOLIZAS: 23524- 63097004</strong>
                      </li>
                      <li>
                        <strong>IDAPLICACION: [vacío]</strong>
                      </li>
                      <li>
                        <strong>IDPOLIZAS: 23524- 63097005</strong>
                      </li>
                      <li>
                        <strong>IDAPLICACION: [vacío]</strong>
                      </li>
                    </ul>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </li>
        <li>
          <strong>Ficheros Recibos:</strong>
          <ul>
            <li>
              En EIAC únicamente enviamos recibos a nivel de colectivo de Cliente/Producto a nivel
              de salud, los dentales siempre se envían recibos individuales. Aunque haya un
              colectivo de pago centralizado de dental se enviaran recibo a recibo y no un único
              recibo. Esto es debido a que los recibos dentales se pueden asignar a más de un recibo
              único y esto no está soportado por el EIAC.
            </li>
            <li>
              <strong>No consta la comisión: </strong>En nuestro sistema GIP nos encontramos con una
              limitación en el sistema, que no nos permite informar de la comisión asociada al
              recibo hasta que{" "}
              <strong>no se ha cobrado el recibo y se ha procesado la liquidación</strong>, es
              decir, en un primer momento irá informado el recibo con comisión CERO, pero una vez
              cobrado el recibo y procesada la liquidación de comisiones, se informa de la comisión
              asociada al recibo. La solución que algunas tecnológicas han implementado es: “Si
              reciben un valor de Comisión 0 y el recibo está pendiente de liquidar o está cobrado
              con automatismo, se sobrescribe la Comisión una vez se informe del dato una vez
              liquidada.
            </li>
            <li>
              <strong>No aparece el orden de la póliza en el fichero de recibos. </strong>El recibo
              se manda a nivel tomador, no a nivel póliza. El orden aparece en los ficheros de
              pólizas, en el campo "IdPoliza".
            </li>
          </ul>
        </li>
      </ul>
    </EiacFilesInfoContainer>
  );
};

export default EiacFilesInfo;
